import * as ecommerce from './ecommerce';
import * as custom from './custom';
import * as error from './error';
import * as views from './views';
export { getGABasketItem } from './utils/getGABasketItem';
export { getGABasketItems } from './utils/getGABasketItems';

// eslint-disable-next-line import/no-anonymous-default-export
export default { views, custom, ecommerce, error };
